const viewportBreakpoint = {
  tablet: 768, //px
  desktop: 1024, //px
}

export { viewportBreakpoint }
